// CP-8243: sender-type visual tokens for conversation message bubbles.
// Two color families (per Martina): blue for operator-side senders (chatbot,
// scheduled automations, team members) and red for guests. Chatbot and
// Automated share identical colors and differ only by tag label; Team gets a
// darker blue border accent so a human sender is spottable against the
// non-human ones. Guest keeps its pre-existing red tag and default bubble
// background, gaining only the left border accent.
//
// Values go through cv() so the chat dark mode can swap them (see themeVars.js);
// the #007AFF / #D98C8C / #9494CE accents read fine on both backgrounds.
import { cv } from '../../themeVars';

export const MESSAGE_TYPE_TOKENS = {
  chatbot: {
    label: 'Chatbot',
    tagBackground: cv('tag-blue', '#DDEDFF'),
    bubbleBackground: cv('bubble-operator', '#EFF4FC'),
    borderAccent: '#007AFF',
  },
  automated: {
    label: 'Automated',
    tagBackground: cv('tag-blue', '#DDEDFF'),
    bubbleBackground: cv('bubble-operator', '#EFF4FC'),
    borderAccent: '#007AFF',
  },
  team: {
    label: 'Team',
    tagBackground: cv('tag-blue', '#DDEDFF'),
    bubbleBackground: cv('bubble-operator', '#EFF4FC'),
    borderAccent: cv('bubble-team-accent', '#1C61BF'),
  },
  guest: {
    label: 'Guest',
    tagBackground: cv('tag-pink', '#F8D7DA'),
    borderAccent: '#D98C8C',
  },
  // Guides are operator-side humans but not office staff: purple keeps that
  // distinction visible (matching the pre-existing chip) while staying closer
  // to the blue family than the guest red. Border/tint derived from the chip
  // lavender the same way guest's #D98C8C derives from its #F8D7DA chip.
  guide: {
    label: 'Tour Guide',
    tagBackground: cv('tag-lavender', '#E4E4F9'),
    bubbleBackground: cv('bubble-guide', '#F2F2FB'),
    borderAccent: '#9494CE',
  },
};

// Vertical gap above a message: tight within a same-sender run, wider when
// the sender changes.
export const SAME_SENDER_GAP_PX = 6;
export const DIFFERENT_SENDER_GAP_PX = 20;
